import React from 'react';
import { useSelector } from 'react-redux';
import { MediaType } from '../../models/mediaClass';

import SimpleVideoPlayerComponent from '../producerPlayer/SimplePlayerVideo';


export const Backgrounds = () => {

  const background = useSelector((state: any) => state.media.background);

  let backgroundSource = `url(${process.env.PUBLIC_URL}/backgrounds/default-chessboard.png)`;
  let backgroundVideo = null;

  if (background) {

    console.log('background', background);

    if (background.type === MediaType.BG_IMAGE && background.source !== '') {
      backgroundSource = `url(${background.source}`;
    }

    if (background.type === MediaType.BG_VIDEO && background.mp4 !== '') {
      backgroundVideo = background.mp4;
      backgroundSource = '';
    }
  }

  return (
    <>
      <div className='LivePreview-background' style={{ backgroundImage: backgroundSource }}></div>
      {backgroundVideo &&
        <SimpleVideoPlayerComponent url={backgroundVideo} name={'background'}></SimpleVideoPlayerComponent>
      }
    </>
  )
}


